module.exports = __webpack_public_path__ + "img/resized-APP-0019-1.c98396e7.png";